import { CampaignTemplateSmsRequest, CampaignTemplateSmsResponse } from '../../api-models';
import { UploadSmsTemplate } from '../../types/campaigns.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostUploadCampaignSmsTemplate extends BaseAdapter<CampaignTemplateSmsResponse> implements AdapterInterface {
  rawResponse: CampaignTemplateSmsResponse;

  modifiedRequest: CampaignTemplateSmsRequest;

  async adaptResponse(request: { template: string }): Promise<UploadSmsTemplate> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/upload-campaign-sms-template', HTTPMethod.Post, formattedRequest);
    return {
      smsTemplateId: this.rawResponse.sms_template_id,
      templateText: request.template,
    };
  }

  adaptRequest(request: { template: string }): CampaignTemplateSmsRequest {
    this.modifiedRequest = {
      template: request.template,
    };
    return this.modifiedRequest;
  }
}
